import { gql } from 'graphql-request'

export const GET_LIVE_CHECKIN_LEVELS_REWARDS = gql`
  query GET_LIVE_CHECKIN_LEVELS_REWARDS(
    $take: Int
    $skip: Int
    $liveCheckinLevelId: Int
    $active: Boolean
    $deleted: Boolean
  ) {
    getLiveCheckinLevelsRewards(
      take: $take
      skip: $skip
      liveCheckinLevelId: $liveCheckinLevelId
      active: $active
      deleted: $deleted
    ) {
      status
      error
      totalPages
      data {
        id
        liveCheckinLevelId
        liveCheckinRewardType
        itemId
        rewardAmount
        durationInDay
        nameKey
        internalName
        sortOrder
      }
    }
  }
`
